import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { authHeader } from "@/utils/headers";

interface WorkflowIdByNameResponse {
  success: boolean;
  workflow_id: number;
  workflow: {
    id: number;
    name: string;
    workspace_id: number;
    is_draft: boolean;
    folder_id: number | null;
  };
}

const useGetWorkflowIdByName = (workflowName?: string) => {
  const workspaceId = useUser()?.activeWorkspaceId ?? 0;
  const userToken = useUserToken();

  return useQuery<WorkflowIdByNameResponse>({
    queryKey: ["workflow-id-by-name", workspaceId, workflowName],
    queryFn: async () => {
      const response = await fetch(
        ENDPOINTS.resolve_workflow_name(workspaceId, encodeURIComponent(workflowName ?? "")),
        {
          method: "GET",
          headers: authHeader(userToken),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch workflow");
      }

      const data = await response.json();
      return data;
    },
    enabled: !!workspaceId && !!workflowName,
  });
};

export default useGetWorkflowIdByName;
